import { OrderStats } from '@/types/orderStats';

// 1 立即处理 2进行中 3已转单 4已上报 5挂单 6已完成 7已关闭 30 退回
export function bottomBtnOrderState(state: number) {
  var i = 0;
  if (state <= OrderStats._220) {
    i = 1;
  } else if (state > OrderStats._220 && state < OrderStats._553 &&
    state !== OrderStats._331 && state !== OrderStats._551 && state !==
        OrderStats._553) {
    i = 2;
  } else if (state === OrderStats._331) {
    i = 3;
  } else if (state === OrderStats._551) {
    i = 4;
  } else if (state === OrderStats._553) {
    i = 5;
  } else if (state >= OrderStats._771 && state <= OrderStats._880) {
    i = 6;
  } else if (state >= OrderStats._990) {
    i = 7;
  } else if (state === OrderStats._556) {
    i = 8;
  }
  return i;
}

// 1立即处理  2签到(选择了上门) - 完成 3选择了寄修处理 -  追加信息 4确认收货(寄修-用户发货) 5寄回(寄修-收到货物完成维修 APP没有寄回 直接是服务完成)  6确认完成(送 远 上)  7关闭  8已上报 9 转派(转出) 10 任务完成     //送修 550350 走 4 和远程一样
export function bottomBtnTaskState(state: number) {
  var i = 0;
  if (state <= OrderStats._330210) {
    i = 1;
  } else if ((state >= OrderStats._550320 && state < OrderStats._550330) ||
        (state <= OrderStats._550523 && state > OrderStats._550525)) {
    i = 2;
  } else if (state === OrderStats._550330) {
    i = 3;
  } else if (state >= OrderStats._550533 && state < OrderStats._550535) {
    i = 4;
  } else if (state >= OrderStats._550535 && state < OrderStats._550701) {
    i = 5;
  } else if ((state >= OrderStats._550525 && state < OrderStats._550533) ||
        (state > OrderStats._330210 && state <= OrderStats._550310) ||
        state === OrderStats._550350 || state === OrderStats._550390) {
    i = 6;
  } else if (state >= OrderStats._550910 && state <= OrderStats._550912) {
    i = 7;
  } else if (state === OrderStats._551920) {
    i = 8;
  } else if (state === OrderStats._550745) {
    i = 9;
  } else {
    i = 10;
  }
  return i;
}

// 0 正常单 1 转入单 2转出单 3及转出又转入
export function isTransfer(iner: number, out: number) {
  var i = 0;
  if (iner === 0 && out === 0) {
    i = 0;
  } else if (iner === 1 && out === 0) {
    i = 1;
  } else if (iner === 0 && out === 1) {
    i = 2;
  } else {
    i = 3;
  }
  return i;
}

export function isFinish(state: number) {
  if (state < OrderStats._10 && state >= OrderStats._7) {
    return true;
  }
  if (state < OrderStats._1000 && state >= OrderStats._771) {
    return true;
  }
  return false;
}
